import { render, staticRenderFns } from "./PatientDataTable.vue?vue&type=template&id=9c20bff2&scoped=true"
import script from "./PatientDataTable.vue?vue&type=script&lang=js"
export * from "./PatientDataTable.vue?vue&type=script&lang=js"
import style0 from "./PatientDataTable.vue?vue&type=style&index=0&id=9c20bff2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c20bff2",
  null
  
)

export default component.exports